import {
    Box, Button, Dialog, Slide, TextField
} from '@mui/material';
import {VisibilityOutlined} from '@mui/icons-material';
import './lessonEdit.styles.scss';
import React, {useState} from 'react';
import {TransitionProps} from "@mui/material/transitions";
import TaskTypeSelectModal from "../../../../modal/task-type-select-modal/TaskTypeSelectModal";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const LessonEdit = ({close}: any) => {
    /*const [lessons, setLessons] = useState([
        {
            name: 'Введение',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        }
    ]);*/

    const [editLesson, setEditLesson] = useState(false);
    const [openTaskAdd, setOpenTaskAdd] = useState(false);
    const [currentLesson, setCurrentLesson] = useState({
        name: '',
        description: '',
    });

    const handleCloseTaskAdd = (selectedType: string) => {
        setOpenTaskAdd(false);
    };

    return (
        <Box>
                <div>
                    <div className="course-create-header">
                        <div className="course-create-header-info">
                            <h4>Программа курса</h4>
                            <div className="steps-count">Excel для начинающих</div>
                        </div>
                        <Button className="close-modal-btn"
                                variant="outlined"
                                onClick={() => close()}
                                sx={{
                                    marginLeft: 'auto',
                                }}
                        >
                            Выйти
                        </Button>
                    </div>
                    <div className="lessons-edit-body">
                        <div className="lessons-container">
                            <div className="one-lesson">
                                <div className="lesson-index">Урок 1</div>
                                <div className="lesson-name">Название урока</div>
                                <div className="lesson-description">Описание урока</div>
                                <Button sx={{padding: '6px', fontSize: '14px', marginTop: '12px'}}
                                        variant="outlined"
                                        fullWidth
                                        onClick={() => setOpenTaskAdd(true)}
                                >
                                    Добавить задание
                                </Button>
                            </div>
                            <Button onClick={() => setEditLesson(true)}
                                variant="contained"
                                sx={{marginTop: '32px'}}
                                fullWidth>
                                Добавить урок
                            </Button>
                        </div>
                        {!editLesson &&
                            <div className="empty-lessons">
                                <div className="empty-lessons-title">Добавьте урок или задание</div>
                                <div className="empty-lessons-description">
                                    Или просмотрите свой курс в качестве студента, чтобы убедиться,<br/>
                                    что все выглядит коректно
                                </div>
                            </div>
                        }
                        {editLesson &&
                            <div className="lesson-edit-wrapper">
                                <div className="lesson-edit">
                                    <div className="lesson-edit-title">Общая информация</div>
                                    <TextField label={'Название урока'} sx={{marginBottom: '32px'}}/>
                                    <TextField className="description-input"
                                               multiline
                                               minRows={4}
                                               maxRows={6}
                                               inputProps={{ maxLength: 300 }}
                                               label="Описание урока"
                                               onChange={(e: any) => setCurrentLesson({
                                                   ...currentLesson,
                                                   description: e.target.value
                                               })}
                                    />
                                    <div className="description-input-counter">{currentLesson.description.length}/300</div>
                                </div>
                                <div className="controls">
                                    <Button variant="contained">Сохранить</Button>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="course-create-footer">
                        <Button disabled={true} variant="outlined" startIcon={<VisibilityOutlined/>}>Предпросмотр</Button>
                        <Button sx={{marginLeft: 'auto', marginRight: '20px'}} variant="outlined">Сохранить как черновик</Button>
                        <Button variant="contained">Отправить на проверку</Button>
                    </div>
                </div>
            <Dialog
                scroll="body"
                open={openTaskAdd}
                onClose={handleCloseTaskAdd}
                TransitionComponent={Transition}
            >
                <TaskTypeSelectModal close={handleCloseTaskAdd}/>
            </Dialog>
        </Box>
    )
}

export default LessonEdit;
